import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("wp_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      if (data.workspace_slug) localStorage.setItem("wp_ws_slug", data.workspace_slug);
      setUser(data);
    } catch {
      localStorage.removeItem("wp_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("wp_token", data.token);
    if (data.user.workspace_slug) localStorage.setItem("wp_ws_slug", data.user.workspace_slug);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("wp_token", data.token);
    if (data.user.workspace_slug) localStorage.setItem("wp_ws_slug", data.user.workspace_slug);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("wp_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refresh: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
